const UserRoles = {
  ADMIN: 'cooperate',
  CALLCENTER_REP: 'crcallcenter',
  TRANSPORT_COORDINATOR: 'cdispatcher',
};

export function getUserRoles() {
  return UserRoles;
}
